import { Grid, Stack, Typography } from "@mui/material";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import KeyValueColumn from "../../common/KeyValueColumn";

interface Props {
  lastChangedBy: string | undefined;
  lastChangedOn: string | undefined;
}

const PassthroughSetup = ({ lastChangedBy, lastChangedOn }: Props) => {
  return (
    <Stack spacing={1}>
      <Typography variant="subtitle1">Setup</Typography>
      <Grid container spacing={5}>
        <Grid>
          <KeyValueColumn title="Modified by" value={lastChangedBy || "-"} />
        </Grid>
        <Grid>
          <KeyValueColumn title="Modified at" value={lastChangedOn ? convertISODateTime(lastChangedOn) : "-"} />
        </Grid>
      </Grid>
    </Stack>
  );
};

export default PassthroughSetup;
